import { defineWave } from '../schema';

/** BLOC F1 — LE FLANC. L'Égide introduite seule.
 *
 *  ── Ce qu'elle change ──
 *  Jusqu'ici, tirer sur un ennemi le tue. L'Égide est le premier ennemi que le
 *  tir de face ne peut pas entamer : son bouclier absorbe dans un cône de ±55°
 *  vers le bas, c'est-à-dire exactement là où se trouve le joueur par défaut.
 *
 *  Le plan l'appelle un « révélateur de build », et c'est littéral. Un tir
 *  frontal et concentré n'obtient rien tant qu'on ne s'est pas déplacé ; une
 *  volée large ou des drones d'escorte écartés en touchent naturellement les
 *  flancs. Deux joueurs équipés différemment ne vivent pas le même ennemi — ce
 *  qui est le but, et ce qui n'arrive jamais avec un ennemi qui n'a que des PV.
 *
 *  ── Introduite seule, et immobile ──
 *  Les dix premières secondes ne contiennent qu'une Égide postée. Rien ne
 *  presse, rien d'autre ne menace : le joueur a le temps de tirer, de constater
 *  que ça ne marche pas, de bouger, et de comprendre pourquoi ça marche
 *  maintenant. Cette séquence de quatre gestes est la leçon entière, et elle ne
 *  passe pas si quoi que ce soit d'autre demande de l'attention pendant ce
 *  temps.
 *
 *  ── Puis le contexte revient ──
 *  À partir de 12 s, l'Égide n'est plus seule. Contourner devient coûteux
 *  puisque le flanc est aussi l'endroit où les Rôdeurs installent leurs
 *  éventails. Le choix n'est plus « comment la tuer » mais « est-ce que ça vaut
 *  la peine maintenant ». */
export default defineWave({
  id: 'f1-flanc',
  duration: 28,
  spawns: [
    { at: 0.5, enemy: 'egide', lane: 3, count: 1, spacing: 0 },
    // Guêpe : feinte, pique, remonte. Attendre le vrai passage plutôt que réagir
    // à chaque perche — le sang-froid.
    { at: 8.0, enemy: 'guepe', lane: 3, count: 1, spacing: 0 },
    { at: 12.0, enemy: 'rodeur', lane: 1, count: 1, spacing: 0 },
    { at: 12.4, enemy: 'rodeur', lane: 5, count: 1, spacing: 0 },
    { at: 15.0, enemy: 'egide', lane: 2, count: 1, spacing: 0 },
    { at: 15.5, enemy: 'egide', lane: 4, count: 1, spacing: 0 },
    // Lame : le danger arrive à l'HORIZONTALE dans le couloir d'esquive ; la
    // parade est verticale. Deux à contresens se coupent au centre.
    { at: 18.0, enemy: 'lame-a', lane: 1, count: 1, spacing: 0 },
    { at: 18.0, enemy: 'lame-b', lane: 5, count: 1, spacing: 0 },
    { at: 19.0, enemy: 'mite', lane: 3, count: 8, spacing: 0.07 },
    { at: 22.0, enemy: 'dard', lane: 3, count: 4, spacing: 0.45 },
    { at: 25.0, enemy: 'faucheur', lane: 2, count: 1, spacing: 0 },
  ],
});
